import { useMemo } from 'react';
import { COMMON_FLAGS } from '../../account-configurations';
import useCommonConfig from '../../account-configurations/hooks/useCommonConfig';
import { SPAN_SCOPE } from '../config/spanScope';

export const useTracerFilterConfig = () => {
    const { [COMMON_FLAGS.PERFORMANCE_MEASUREMENT_REPORT_TYPE]: reportTypes } = useCommonConfig([
        COMMON_FLAGS.PERFORMANCE_MEASUREMENT_REPORT_TYPE,
    ]);

    const { [COMMON_FLAGS.PERFORMANCE_MEASUREMENT_REPORT_DATE_RANGE]: dateRangeFilter } = useCommonConfig([
        COMMON_FLAGS.PERFORMANCE_MEASUREMENT_REPORT_DATE_RANGE,
    ]);

    const reportTypesSet = useMemo(() => {
        try {
            return new Set(reportTypes.split(','));
        } catch (error) {
            console.error('Error parsing report types:', error);
            return [];
        }
    }, [reportTypes]);

    const dateRangeSet = useMemo(() => {
        try {
            return new Set(dateRangeFilter.split(','));
        } catch (error) {
            console.error('Error parsing date range:', error);
            return [];
        }
    }, [dateRangeFilter]);

    const SPAN_MATRICS_CONFIG = {
        [SPAN_SCOPE.REPORT_SCOPE]: { reportId: reportTypesSet, dateRange: dateRangeSet },
    };

    return SPAN_MATRICS_CONFIG;
};
